import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: { justifyContent: 'center' },
});

export default styles;
